/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Actions_UploadInputs */

const es_settings_files_actions_upload = /** @type {(inputs: Settings_Files_Actions_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir archivos`)
};

const en_settings_files_actions_upload = /** @type {(inputs: Settings_Files_Actions_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload files`)
};

/**
* | output |
* | --- |
* | "Upload files" |
*
* @param {Settings_Files_Actions_UploadInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_actions_upload = /** @type {((inputs?: Settings_Files_Actions_UploadInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Actions_UploadInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_actions_upload(inputs)
	return en_settings_files_actions_upload(inputs)
});
export { settings_files_actions_upload as "settings.files.actions.upload" }